import axios from 'axios';
import {
  EDITOR_LOAD_PROJECT_BEGIN,
  EDITOR_LOAD_PROJECT_SUCCESS,
  EDITOR_LOAD_PROJECT_FAILURE,
  EDITOR_LOAD_PROJECT_DISMISS_ERROR,
} from './constants';

export function loadProject(args = {}) {
  return (dispatch) => {
    dispatch({
      type: EDITOR_LOAD_PROJECT_BEGIN,
    });
    const { projectId, version } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: EDITOR_LOAD_PROJECT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: EDITOR_LOAD_PROJECT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectError() {
  return {
    type: EDITOR_LOAD_PROJECT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EDITOR_LOAD_PROJECT_BEGIN:
      return {
        ...state,
        loadProjectPending: true,
        loadProjectError: null,
      };

    case EDITOR_LOAD_PROJECT_SUCCESS:
      return {
        ...state,
        loadProjectPending: false,
        loadProjectError: null,
        project: action.data,
      };

    case EDITOR_LOAD_PROJECT_FAILURE:
      return {
        ...state,
        loadProjectPending: false,
        loadProjectError: action.data.error,
      };

    case EDITOR_LOAD_PROJECT_DISMISS_ERROR:
      return {
        ...state,
        loadProjectError: null,
      };

    default:
      return state;
  }
}
